import { UserType } from './user.model';

export enum EAccountStatus {
  OK = 'ok',
  WARNING = 'warning',
  DANGER = 'danger',
}

export interface IVisibleUsers {
  email: string;
  first_name: string;
  last_name: string;
  id: number;
  role: UserType;
}

export enum EAccountReportStatus {
  DISABLED,
  CONTACTS_ONLY,
  CONTACTS_AND_CLOSER,
  CLOSER_ONLY
}

export const ACCOUNT_REPORT_TYPES = {
  [EAccountReportStatus.CONTACTS_ONLY]: 'contacts',
  [EAccountReportStatus.CONTACTS_AND_CLOSER]: 'users',
  [EAccountReportStatus.CLOSER_ONLY]: 'users',
};

export interface IAccount {
  account_id: number;
  account_role: UserType;
  report_status?: EAccountReportStatus;
  actions: string[];
  contact_record: number;
  created_at: string;
  email: string;
  first_name: string;
  forward_email_enabled: boolean;
  last_name: string;
  last_signin: string;
  manager_id: number;
  notification_email: string;
  notification_email_enabled: boolean;
  partner_id: number;
  c2recruit?: boolean;
  status: EAccountStatus;
  unknown_messages: number;
  unread_messages: number;
  unread_old_messages: number;
  vsm_id: number;
  visible_users: IVisibleUsers[];

  confirmed_at?: string;
  vsm_group_id?: number;
  group_status?: boolean;
  invoiced?: boolean;
}

export interface IAccountUpdateResult {
  account_id: number;
}

export interface IAccountReportUsersColumns {
  Category: string;
  address: string;
  bounced: string;
  city: string;
  company: string;
  current_pipeline_step: string;
  current_product: number;
  current_status: string;
  date_added_to_retreva: string;
  email: string;
  email_position: number;
  first_name: string;
  industry1: string;
  last_name: string;
  next_email_at: string;
  phone: number;
  private_note: string;
  source: string;
  state: string[];
  status: string;
  tags: string;
  title: string;
  user_contact_id: number;
  user_id: number;
  variable_1: string;
  variable_2: string;
  variable_3: string;
  vip: string;
  won_amount: string;
  zip: string;
}

export interface IAccountReportCloserColumns {
  account_created_at: string;
  account_id: number;
  account_note: string;
  active_contacts: number;
  amount_gained: string;
  city: string;
  company: string;
  contacts_added_in_last_year: number;
  contacts_added_last_30_days: number;
  contacts_added_last_90_days: number;
  contacts_in_service: number;
  country: string;
  current_meetings: number;
  current_orders: number;
  current_quotes: number;
  cycle: number;
  email: string;
  first_name: string;
  follow: number;
  identifier_number: string;
  inactive: number;
  integration_contacts_added_last_30_days: number;
  integration_data_sync_on: string;
  integration_total_contacts_added: number;
  invoice_note: string;
  last_name: string;
  lost: number;
  manager_email: string;
  opportunities: number;
  optional_note_a: string;
  optional_note_b: string;
  other: number;
  partner_email: string;
  red_no_matches: number;
  remove: number;
  retreva_service: string;
  service_flag: string;
  spam: number;
  state: string;
  unread_visible_messages: number;
  visible_messages: number;
  vsm_messages: number;
  vsm_released: number;
  won: number;
  zip: string;
}
